import { Component, ViewChild, OnInit, signal } from '@angular/core';
import Check from 'framework/Check';
import CustomerAccountTypeGroup from 'app/customeraccount/CustomerAccountTypeGroup';
import System from 'framework/System';
import partner from 'app/models/partner';
import { PublishOptionsComponent } from '../../shared/publish-options/publish-options.component';
import { SaveTypes } from 'app/models/enums/SaveTypes';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import ImplementationOwners = Boo.Objects.Enums.ImplementationOwners;
import Utils from '../../../shared/utils';

@Component({
  selector: 'app-components-managecustomer-logins-and-google-setup',
  templateUrl: './logins-and-google-setup.component.html'
})
export class LoginsAndGoogleSetupComponent implements IActivatable, OnInit {
  isLoading: boolean;
  customer: CustomerObservable;
  user: Boo.Objects.User;
  customerAccountGroupPublicApi: app.interfaces.ISave;
  hasGoogleAnalyticsAccess: boolean;
  accounts: app.managecustomer.components.interfaces.CustomerAccountViewModel[];
  refreshCustomer: () => void;
  blog: number[] = CustomerAccountTypeGroup.blog;
  seo: number[] = CustomerAccountTypeGroup.seo;
  websites: number[] = CustomerAccountTypeGroup.website;
  showSaveButton: boolean;
  title = 'Logins & Google Setup';
  partner: any = ko.observable(new partner());
  @ViewChild(PublishOptionsComponent) publishOptionsComponent: PublishOptionsComponent;
  contentManagementSystem: Boo.Objects.ContentManagementSystem;
  enableWebsiteAccessTab: KnockoutComputed<boolean>;
  isNotIonosPartner: KnockoutObservable<boolean>;
  tabPanelDisplayMode = TabPanelDisplayMode;
  currentImplementationOwner = signal(ImplementationOwners.NotSelected);

  canActivate(user: Boo.Objects.User, partner: Boo.Objects.Partner, params: any): boolean {
    Check.isNotEmpty(params, 'Activation parameters are required');
    Check.isNotEmpty(params.customer, 'Customer is required for activation');

    this.isLoading = true;
    if (params.refreshCustomer) {
      this.refreshCustomer = params.refreshCustomer;
    }
    this.customer = params.customer;
    this.user = user;
    return params.customer;
  }

  ngOnInit(): void {
    this.showSaveButton = true;
    this.isNotIonosPartner = ko.observable(this.customer.PartnerId() !== Boo.Objects.Enums.PartnerEnum.OneAndOneIonosSe);    

    this.isLoading = false;

    Check.isNotEmpty(this.customer, 'A customer is required to edit Onsite Recommendation settings.');
  }

  customerAccountGroupApiCallback(publicApi: app.interfaces.ISave): void {
    this.customerAccountGroupPublicApi = publicApi;
  }

  save(): JQueryPromise<void> {
    this.isLoading = true;
    if (!this.customerAccountGroupPublicApi) {
      toastr.error('Could not save logins & Google setup. Missing public api');
      this.isLoading = false;

      return System.emptyPromise();
    }

    const validatedResult = this.publishOptionsComponent.validate(SaveTypes.Complete);
    if (!validatedResult.isValid) {
      validatedResult.errorMessages.forEach(message => toastr.error(message));
      this.isLoading = false;
      
      return System.emptyPromise();
    }

    return this.customerAccountGroupPublicApi.save()
      .then(() => Utils.wrapDfd(this.publishOptionsComponent.save()))
      .then(() => {
        toastr.success('Publish options saved.');
        return System.emptyPromise();
      })
      .fail((displayMessage: string) => {
        toastr.error(displayMessage);
      })
      .always(() => {
        this.isLoading = false;
      });
  }
}